<script>
  import { onMount } from 'svelte'
  import {fade} from 'svelte/transition'

  import TabulatorBare from '../../UC-tabulator-bare.svelte'

  export let tableTitle = ''
  export let dashboardState
  export let loading = false
  export let error = false

  // Extract table data from dashboardState
  $: tableData = dashboardState?.tableData || []
  $: tableLoading = dashboardState?.tableLoading ?? false
  
  // Debug logging
  /*$: {
    console.log('WebsitesTable - dashboardState:', dashboardState)
    console.log('WebsitesTable - tableData:', tableData)
    console.log('WebsitesTable - tableData length:', tableData?.length)
  }*/

  // We'll bind this to the instance of TabulatorBare so we can call its exported download function from exportData()
  // let tabulatorComponentRef = undefined

  // URL formatter to make URLs clickable
  const urlFormatter = (cell) => {
    const value = cell.getValue()
    if (value && (value.startsWith('http') || value.startsWith('www'))) {
      const url = value.startsWith('http') ? value : `https://${value}`
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${value}</a>`
    }
    return value || ''
  }

  const tableColumns = [
    { 
      title: "<span class='title'>Site Name</span>", 
      field: "SiteName",
      minWidth: 200
    },
    { 
      title: "<span class='title'>URL to Site</span>", 
      field: "SiteUrl",
      minWidth: 300,
      formatter: urlFormatter
    },
  ]

  // Force data update when tableData changes
  /*$: if(tableData && tableData.length > 0 && tabulatorComponentRef) {
    console.log('Updating tabulator with data:', tableData)
    // Use a small delay to ensure tabulator is fully initialized
    setTimeout(() => {
      if (tabulatorComponentRef && tabulatorComponentRef.setData) {
        tabulatorComponentRef.setData(tableData)
      }
    }, 100)
  }*/

  /*const exportData = ()=>{
    if(tabulatorComponentRef) {
      tabulatorComponentRef.triggerDownload('websites-export')
    }
  }*/

  onMount(() => {
    console.log('WebsitesTable mounted with data:', tableData)
  })
</script>

<div class="uc-tabulator websites-tabulator w-full" aria-live="polite">
  <header>
    <div class="table-title">
      <h3>{@html tableTitle}</h3>
    </div>
  </header>
  
  <!-- Add debug info 
  <div style="padding: 1rem; background: #f0f0f0; margin: 1rem;">
    <p>Debug Info:</p>
    <p>Dashboard State: {JSON.stringify(dashboardState)}</p>
    <p>Table Data Length: {tableData?.length || 0}</p>
    <p>Loading: {loading}</p>
    <p>Error: {error}</p>
  </div>-->
  
  {#if loading || (tableLoading && tableData.length === 0)}
    <div class="loading" role="status" aria-label="Loading websites data">
      <p><i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i> Loading websites data...</p>
    </div>
  {:else if error || tableData?.error}
    <div class="error" transition:fade>
      <p>There was an error loading the websites data.</p>
    </div>
  {:else if !tableData || tableData.length === 0}
    <div class="no-data" transition:fade>
      <p>No website data available.</p>
    </div>
  {:else}
    <span transition:fade>
      <TabulatorBare data={ tableData } columns={ tableColumns } />
    </span>
    {#if tableLoading}
      <div class="loading-more" role="status" aria-live="polite" aria-label="Loading more websites">
        <p><i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i> Loading more sites...</p>
      </div>
    {/if}
  {/if}
</div>

<!--<div class="export-wrap">
  <button on:click={ exportData }>Download CSV</button>
</div>-->

<span class="hidden tabulator-row tabulator-cell sr-only table-filter"></span>

<style>
  .websites-tabulator, .w-full {
    width: 100%;
  }

  div.loading, div.error, div.no-data {
    padding: 4rem;
    text-align: center;
    display: grid;
    justify-content: center;
    align-items: center;
  }

  .loading i, .loading-more i {
    color: var(--uc-red);
  }

  .loading-more {
    padding: 1rem 4rem;
    text-align: center;
    display: grid;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #f0f0f0;
  }

  h3 {
    color: var(--uc-red);
    font-size: 3rem;
    font-weight: 600;
    padding: 2rem 0;
  }

  .uc-tabulator {
    border-radius: 1rem;
    background-color: #FFF;
    filter: drop-shadow(0.2em 0.2em 0.2em rgba(0, 0, 0, 0.15));
    margin-bottom: 3rem;
  }

  .sr-only {
    display: none;
  }

  header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  @media(max-width:768px){
    header {
      flex-direction: column;
      align-items: center;
    }
  }

  .table-title {
    color: var(--uc-red);
    padding: 0 2rem;
  }

  /* Make URLs clickable and styled */
  :global(.tabulator-cell a) {
    color: var(--uc-red);
    text-decoration: underline;
  }

  :global(.tabulator-cell a:hover) {
    color: #cc0000;
  }
</style>